<div class="container-fluid m-0 p-0" *ngIf="checkDataExist()">
    <div class="row">
        <div class="col-12 mt-4">
            <div class="border-bottom font-16 mb-3 text-bold">{{ "TAB_GENERAL_DATA" | translate | titlecase }}</div>
        </div>
        <div class="col-12">
            <div class="row m-0 p-3 bg-light-grey">
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "LIVE_WITH" | translate | titlecase }}</label>
                    <p class="cand-answer">{{(globals.lang == 'ar')? candData.liveWithNameAr :
                        candData.liveWithNameEn}}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "LIVE_WITH_OTHER" | translate | titlecase }}</label>
                    <p class="cand-answer">{{candData.livewithOther }}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "LIVE_WITH_MOBILE_1" | translate | titlecase }}</label>
                    <p class="cand-answer">{{candData.relative1Mob }}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "LIVE_WITH_MOBILE_2" | translate | titlecase }}</label>
                    <p class="cand-answer">{{candData.relative2Mob }}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "LIVE_WITH_CONTACT_1" | translate | titlecase }}</label>
                    <p class="cand-answer">{{candData.relation1 }}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "LIVE_WITH_CONTACT_2" | translate | titlecase }}</label>
                    <p class="cand-answer">{{candData.relation2 }}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "SIBLINGS_COUNT" | translate | titlecase }}</label>
                    <p class="cand-answer">{{candData.siblingsCount }}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "CAND_SIBLINGS_RANK" | translate | titlecase }}</label>
                    <p class="cand-answer">{{candData.candSiblingsRank }}</p>
                </div>

                <div class="col-md-4 mb-2" *ngFor="let question of questionData">
                    <label class="font-bold">
                        {{
                        (globals.lang == 'ar')? question.questionDescAr : question.questionDescEn
                        }}</label>
                    <p class="cand-answer">{{question.answer }}</p>
                </div>

            </div>
        </div>

    </div>
</div>
<app-loader [show]="!checkDataExist()"></app-loader>